import { useHistory, useLocation } from 'react-router-dom';

import { checkIfUrlSafe } from 'store/auth/utils/utils';
import { useGoToExplore } from 'features/mobile-report/hooks/use-go-to-explore';
import { useRouteParam } from 'hooks/use-query/use-query';

export const useRedirectToMobile = () => {
    const goToExplore = useGoToExplore();
    const history = useHistory();
    const location = useLocation();

    const nextUrl = useRouteParam('next_url') || '';

    return (next_url?: string) => {
        const selectedNextUrl = next_url || nextUrl;

        history.replace({
            pathname: location.pathname,
            search: location.search,
            state: undefined,
        });

        selectedNextUrl && checkIfUrlSafe(selectedNextUrl)
            ? history.push(selectedNextUrl.replace(`${window.location.origin}`, ''))
            : goToExplore();
    };
};
